var _ellipse, _rect, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1193,
    viewBox: "0 0 1920 1193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 978,
    cy: 3.5,
    rx: 1377,
    ry: 571.5,
    fill: "url(#paint0_radial_341_815)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2103.94,
    y: 1192.27,
    width: 910,
    height: 291,
    rx: 145.5,
    transform: "rotate(-158.033 2103.94 1192.27)",
    fill: "url(#paint1_radial_341_815)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1726,
    y: 616,
    width: 521,
    height: 291,
    rx: 145.5,
    transform: "rotate(180 1726 616)",
    fill: "url(#paint2_radial_341_815)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1358.33,
    y: -3.43506,
    width: 583.562,
    height: 326.239,
    rx: 163.119,
    transform: "rotate(135 1358.33 -3.43506)",
    fill: "url(#paint3_radial_341_815)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -53.9999,
    y: 965,
    width: 808,
    height: 452,
    rx: 226,
    transform: "rotate(-90 -53.9999 965)",
    fill: "url(#paint4_radial_341_815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_341_815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 3.5) rotate(90) scale(674.5 1625.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0A1A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_341_815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2392.13 642.773) rotate(72.6348) scale(895.521 2632.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_341_815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1986 -61.4999) rotate(86.6209) scale(984.416 1762.41)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_341_815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1135.77 -598.542) rotate(42.4013) scale(1003.53 1795.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_341_815",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(846 -14) rotate(105.64) scale(1508.93 2698.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9EF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868563,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.2a0760e98e7330fb3bd16edaf39c8bff.svg";
export { ForwardRef as ReactComponent };